require('./common-wrapper-b.jade')

CommonWrapperBDirective =  ->
  restrict: "A"
  transclude: true
  templateUrl: "components/common-wrapper/common-wrapper-b.jade"

module.exports = CommonWrapperBDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-wrapper/common-wrapper-b-directive.coffee